import React from 'react';
import { Select, Space, Tag, Typography } from 'antd';
import PropTypes from 'prop-types';

import { AimOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SET_TYPE_ICONS = {
    strategy: <AimOutlined />,
    noStrategy: <QuestionCircleOutlined />
};

export default function SetSelector({ availableSets, selectedSet, onSelectSet }) {
    const handleChange = (value) => {
        if (!value) {
            onSelectSet(null);
            return;
        }

        const [setType, setNumber] = value.split('-');
        onSelectSet({ setType, setNumber: parseInt(setNumber, 10) });
    };

    const currentValue = selectedSet
        ? `${selectedSet.setType}-${selectedSet.setNumber}`
        : undefined;

    return (
        <div className="set-selector">
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Text strong>Select Strategy Set to Analyze</Text>
                <Select
                    style={{ width: '100%', maxWidth: 400 }}
                    placeholder="Choose a strategy set..."
                    value={currentValue}
                    onChange={handleChange}
                    allowClear
                    options={availableSets.map((set) => ({
                        value: `${set.value.setType}-${set.value.setNumber}`,
                        label: (
                            <Space>
                                {SET_TYPE_ICONS[set.value.setType]}
                                <span>{set.label}</span>
                                <Tag>{set.trades} trades</Tag>
                            </Space>
                        )
                    }))}
                />
            </Space>
        </div>
    );
}

SetSelector.propTypes = {
    availableSets: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.shape({
                setType: PropTypes.oneOf(['strategy', 'noStrategy']).isRequired,
                setNumber: PropTypes.number.isRequired
            }).isRequired,
            trades: PropTypes.number.isRequired
        })
    ).isRequired,
    selectedSet: PropTypes.shape({
        setType: PropTypes.oneOf(['strategy', 'noStrategy']).isRequired,
        setNumber: PropTypes.number.isRequired
    }),
    onSelectSet: PropTypes.func.isRequired
};

SetSelector.defaultProps = {
    selectedSet: null
};
